module.exports = __webpack_public_path__ + "img/filter.29e73d22.svg";